// extracted by mini-css-extract-plugin
module.exports = {"main-component":"standup_main-component__3frcQ"};